import React, { useState} from 'react'
import "./MatchOdds.css";
import Bookmarks from "./Bookmarks";
import BetModel from "./backbetmodel/BetModel";
import Fancybet from "./Fancybet";

const data =[
  {
    team: "India",
    b1: "1.01",
    b2: "1.08",
    b3: "1.09",
    l1: "960",
    c1: "1.01",
    c2: "1.08",
    c3: "1.09",
    l2: "960",
  },
  {
    team: "South Africa",
    b1: "0",
    b2: "1.01",
    b3: "1.08",
    l1: "960",
    c1: "1.0",
    c2: "1.08",
    c3: "1.09",
    l2: "960",
  }, 
  {
    team: "The Draw",
    b1: "1.01",
    b2: "1.08",
    b3: "1.06",
    l1: "960",
    c1: "1.09",
    c2: "1.08",
    c3: "1.01",
    l2: "960",
  },   
];

const MatchOdds = () => {
    const [show, setShow] = useState(false);
      const [selected, setSelected] = useState(null);
      const [showModal, setShowModal] = useState(false);
      const handleOpen = (team, odd, type) => {
        setSelected({
          team,
          odd,
          type, // <-- Back or Lay
        });
    
        setShow(true);
      };
      const openinfomodele = () => setShowModal(true);
      const closeModal = () => setShowModal(false);
  return (
    <>
      <div className="winner-container">
        <div className="header-row1">
          <span className="header-title1">
            Match Odds{" "}
            <button
              onClick={openinfomodele}
              style={{
                cursor: "pointer",
                marginLeft: "5px",
                background: "none",
                border: "none",
                fontSize: "16px",
                color: "white",
              }}
            >
              ⓘ
            </button>
          </span>
          <span className="matche1">
            Matched <b>€ 10.6K</b>
          </span>
        </div>

        <div className="table-wrapper1">
          <table className="bet-table1">
            <thead>
              <tr>
                <th colSpan={3} className=""></th>
                <th colSpan={1} className="back-heading1">
                  Back
                </th>

                <th colSpan={1} className="lay-heading1">
                  Lay
                </th>
                <th colSpan={2} className="minmax1-heading1">
                  min/max 1- 0
                </th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, i) => (
                <tr key={i}>
                  <td className="team1">{row.team}</td>

                  <td
                    className={`back-cell-1`}
                    onClick={() => handleOpen(row.team, row.b2)}
                  >
                    {row.b1}
                    <br />
                    <span className="right-cell1">{row.c1}</span>
                  </td>
                  <td
                    className={`back-cell-2`}
                    onClick={() => handleOpen(row.team, row.b2)}
                  >
                    {row.b2}
                    <br />
                    <span className="right-cell1">{row.c2}</span>
                  </td>
                  <td
                    className={`back_cell`}
                    onClick={() => handleOpen(row.team, row.b3)}
                  >
                    {row.b3}
                    <br />
                    <span className="right-cell1">{row.c3}</span>
                  </td>

                  <td
                    className={`lay_cell`}
                    onClick={() => handleOpen(row.team, row.l1, "lay")}
                  >
                    {row.l1 || "0"} <br />
                    <span className="right-cell1">{row.l2 || "0"}</span>
                  </td>
                  <td className={`lay_cell1`}>
                    0 <br />
                    <span className="right-cell1">0</span>
                  </td>
                  <td className="minmax">
                    0 <br />
                    <span className="right-cell1">0</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <BetModel
        show={show}
        selected={selected}
        handleClose={() => setShow(false)}
      />
      <Bookmarks />
      <Fancybet />
      {/* Modal */}
      {showModal && (
        <>
          <div className="modal-overlay" onClick={closeModal}></div>

          <div className="modal-box">
            <h3>Information</h3>

            <div className="modal-content">
              {/* Yahan aapka 1000 words ya table aa sakta hai */}
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. 
                (yaha content scroll hoga)
              </p>

              {/* Example table */}
              <table border="1" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.from({ length: 50 }).map((_, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>Item {i + 1}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <button className="close-btn" onClick={closeModal}>
              ok
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default MatchOdds;
